export default __webpack_public_path__ + "static/media/not-courses.c33e9033.svg";